export default __webpack_public_path__ + "static/media/EXR_FactionIcons-03_Mercenary.893ec48b.png";